import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import OtherPaymentBasicInfo from "./OtherPaymentBasicInfo";
import PurchaseHistory from "./PurchaseHistory";
import {useAuthState} from "../../context/AuthContext";

export default function OtherPaymentDetails() {

    const [title, setTitle] = useState("");
    const {state: location} = useLocation()

    const {fundID} = useAuthState()

    useEffect(() => {
        if (location && location.title) {
            setTitle(location.title)
        }
    }, [location, fundID]);

    const [value, setValue] = useState(OtherPaymentDetailsTabTypes.BasicInfo.id);

    function handleChangeTabMenu(event, newValue) {
        setValue(newValue)
    }

    const navigate = useNavigate()

    return (
        <RaikoBaseContainer>
            <RaikoFlexFirstChildGrowOne>
                <RaikoBreadcrumb className={css`flex-grow: 1;
                  gap: .5rem;`} breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.OtherPayments.name,
                        RouteHelper.OtherPayments.globalUrl
                    ),
                    raikoBreadCrumbItemGenerator(
                        title,
                        ""
                    )
                ]}/>
                <RaikoButtonSecondary
                    label={"بازگشت"}
                    onClick={_ => {
                        navigate(-1);
                    }}/>
            </RaikoFlexFirstChildGrowOne>
            <TabContext value={value}>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}
                     className={css`
                       border-color: var(--header-border-bottom-color) !important;
                       margin-top: 24px;
                     `}>
                    <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                        <Tab
                            label={OtherPaymentDetailsTabTypes.BasicInfo.title}
                            value={OtherPaymentDetailsTabTypes.BasicInfo.id}
                        />
                        <Tab
                            label={OtherPaymentDetailsTabTypes.PurchaseHistory.title}
                            value={OtherPaymentDetailsTabTypes.PurchaseHistory.id}
                        />
                    </TabList>
                </Box>
                <TabPanel value={OtherPaymentDetailsTabTypes.BasicInfo.id}>
                    <OtherPaymentBasicInfo/>
                </TabPanel>
                <TabPanel value={OtherPaymentDetailsTabTypes.PurchaseHistory.id}>
                    <PurchaseHistory/>
                </TabPanel>

            </TabContext>
        </RaikoBaseContainer>
    )
}
const OtherPaymentDetailsTabTypes = {
    BasicInfo: {
        id: "basic-info",
        title: "اطلاعات پایه"
    },
    PurchaseHistory: {
        id: "purchase-history",
        title: "سابقه خرید"
    },
}